/** Detect if the rider app runs inside a Capacitor native shell. */

declare global {
  interface Window {
    Capacitor?: {
      isNativePlatform?: () => boolean;
      getPlatform?: () => string;
    };
  }
}

export function isCapacitorNative(): boolean {
  return typeof window !== 'undefined' && window.Capacitor?.isNativePlatform?.() === true;
}

export function getNativePlatform(): 'web' | 'android' | 'ios' {
  if (!isCapacitorNative()) return 'web';
  const platform = window.Capacitor?.getPlatform?.() || 'web';
  return platform === 'android' || platform === 'ios' ? platform : 'web';
}

export function isAndroidApp(): boolean {
  return getNativePlatform() === 'android';
}

export function isIosApp(): boolean {
  return getNativePlatform() === 'ios';
}
